// src/components/shared/DegradedStateBanner.jsx
// Shows at the top of any page when a data source is down or degraded.
// Polls every 60 seconds. Disappears automatically when all sources healthy.

import { useEffect, useState } from 'react'
import { getDataSourceStatus } from '../../lib/marketData'

const SOURCE_NAMES = {
  yahoo_finance: 'Yahoo Finance',
  coincap:       'CoinCap',
  alpha_vantage: 'Alpha Vantage',
}

export default function DegradedStateBanner() {
  const [issues, setIssues] = useState([])

  useEffect(() => {
    async function check() {
      try {
        const sources = await getDataSourceStatus()
        setIssues(sources.filter(s => s.status === 'down' || s.status === 'degraded'))
      } catch {
        // Silently ignore — don't break the page
      }
    }

    check()
    const interval = setInterval(check, 60000)
    return () => clearInterval(interval)
  }, [])

  if (issues.length === 0) return null

  const names = issues.map(i => SOURCE_NAMES[i.id] ?? i.id).join(', ')
  const allDown = issues.every(i => i.status === 'down')

  return (
    <div style={{
      background:    '#150a00',
      border:        '1px solid rgba(245,197,24,0.25)',
      borderRadius:  6,
      padding:       '10px 14px',
      marginBottom:  14,
      display:       'flex',
      alignItems:    'center',
      gap:           10,
      fontFamily:    "'IBM Plex Mono', 'Courier New', monospace",
      flexWrap:      'wrap',
    }}>
      <span style={{ color: '#f5c518', fontSize: 13, flexShrink: 0 }}>⚠</span>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap', flex: 1 }}>
        <span style={{ color: '#f5c518', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em' }}>
          {allDown ? 'DATA UNAVAILABLE' : 'DATA DEGRADED'}
        </span>
        <span style={{ color: '#6b7280', fontSize: 11 }}>
          {names} {issues.length === 1 ? 'is' : 'are'} {allDown ? 'down' : 'experiencing issues'}.
          {' '}Showing last known prices where available.
        </span>
      </div>

      <a
        href="https://status.nuvport.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color:          '#f5c518',
          fontSize:       10,
          textDecoration: 'none',
          letterSpacing:  '0.06em',
          flexShrink:     0,
          opacity:        0.8,
        }}
      >
        Status ↗
      </a>
    </div>
  )
}
